
export default {
  name: "technology",
  props: {
    title: {
      type: String,
      default: ''
    },
    contents: {
      type: Array,
      default: () => []
    },
    img: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: ''
    },
    isEven: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: '/coreTechnology/index'
    }
  },
  data() {
    return {

    }
  },
  methods: {
    linkTechnology(path) {
      if(!path) return
      this.$router.push({
        path: path
      })
    }
  }
}
